import { SubscriptionTiers, useTranslation } from "@next-platform/client-common-core";
import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { Modal } from "@next-platform/client-common-spicy-ui";

import { LocalizedLink } from "@/components";
import { Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import { EXTERNAL_ROUTES_FOR_APPLICATION } from "@/constants";

type ModalPremiumTrainingProps = {
  isOpen: boolean;
  onClose: (open: boolean) => void;
};

export default function ModalPremiumTraining({ isOpen, onClose }: ModalPremiumTrainingProps) {
  const { t } = useTranslation();
  const applicationId = basicAppConfig.applicationId;
  return (
    <Modal
      title={t("chat:modal.premiumTrainingUpgrade.title", { subscriptionTier: SubscriptionTiers.PREMIUM })}
      classNames={{ title: "text-center pl-[28px]" }}
      open={isOpen}
      onOpenChange={onClose}
    >
      <div className="text-center">
        <Trans
          i18nKey="chat:modal.premiumTrainingUpgrade.description"
          values={{ subscriptionTier: SubscriptionTiers.PREMIUM }}
          components={{ b: <b /> }}
        />
        <br />
        <br />
      </div>
      <div className="[&>*:first-child]:flex-wrap [&>*:first-child]:justify-center text-center">
        <Text>
          <Trans
            i18nKey="chat:modal.premiumTraining.moreDetails"
            values={{ linkText: t("chat:modal.premiumTraining.linkText") }}
            components={{
              linkText: (
                <LocalizedLink
                  className="ml-1 text-blue-600"
                  to={`${EXTERNAL_ROUTES_FOR_APPLICATION[applicationId as string]?.docs}/product-guides/premium-features/conversation-images`}
                  target="_blank"
                  aria-label="conversation-images"
                />
              ),
            }}
          />
        </Text>
      </div>
    </Modal>
  );
}
